import dayjs from 'dayjs'
import { Toast } from '@/utils/helper'

export const SHOPPING_MAINTENANCE_TITLE = '購物功能維護中'
export const SHOPPING_MAINTENANCE_MESSAGE = '系統維護中，網站購物暫時關閉。'
export const SETTLEMENT_DAY_MESSAGE =
  '親愛的傳銷商您好，本月份業績已經進行結算作業，暫停所有產品下單，造成不便，深感抱歉!'

export function isShoppingMaintenanceClosed (config = {}) {
  const hasRange = config.started_at && config.finished_at
  const isWithinMaintenanceRange = hasRange
    ? dayjs().isAfter(config.started_at) && dayjs().isBefore(config.finished_at)
    : false

  return Number(config.status) === 0 || isWithinMaintenanceRange
}

export function isSettlementDayClosed (days = []) {
  const settlementDays = Array.isArray(days) ? days : []
  return settlementDays.some(day =>
    Number(day.status) === 1 &&
    day.started_at &&
    day.finished_at &&
    dayjs().isAfter(day.started_at) &&
    dayjs().isBefore(day.finished_at)
  )
}

export function isShoppingMaintenanceError (error) {
  return String(
    error &&
    error.response &&
    error.response.data &&
    error.response.data.status_from_backend
  ) === '4006'
}

export function showSettlementDayMaintenance () {
  return Toast.fire({
    icon: 'warning',
    title: SETTLEMENT_DAY_MESSAGE,
    confirmButtonText: '確認',
    confirmButtonColor: '#00802F',
    allowOutsideClick: false,
    allowEscapeKey: false,
    customClass: {
      confirmButton: 'cart-alert-confirm-button'
    }
  })
}

export function showShoppingMaintenance () {
  return Toast.fire({
    icon: 'warning',
    title: SHOPPING_MAINTENANCE_TITLE,
    text: SHOPPING_MAINTENANCE_MESSAGE,
    confirmButtonText: '確認',
    confirmButtonColor: '#00802F',
    allowOutsideClick: false,
    allowEscapeKey: false,
    customClass: {
      confirmButton: 'cart-alert-confirm-button'
    }
  })
}

export async function showShoppingMaintenanceAndReturnHome (router) {
  await showShoppingMaintenance()
  await router.replace('/')
}
